import { render, staticRenderFns } from "./SeatSettingItem.vue?vue&type=template&id=1d82cd4b&scoped=true&"
import script from "./SeatSettingItem.vue?vue&type=script&lang=js&"
export * from "./SeatSettingItem.vue?vue&type=script&lang=js&"
import style0 from "./SeatSettingItem.vue?vue&type=style&index=0&id=1d82cd4b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d82cd4b",
  null
  
)

export default component.exports